import { render, staticRenderFns } from "./EditStoreShippingComponent.vue?vue&type=template&id=2fb0e1c8&scoped=true"
import script from "./EditStoreShippingComponent.vue?vue&type=script&lang=js"
export * from "./EditStoreShippingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb0e1c8",
  null
  
)

export default component.exports